// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1xnMq","actions":"GroupTable_actions__29nmY","deleteModalFooter":"GroupTable_deleteModalFooter__3dTia"};